import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import RoleForm from "./RoleForm";
import { useCreateRoleMutation } from "../../redux/api/rolesApi";

const AddRolePage = () => {
  const navigate = useNavigate();
  const [createRole, { isLoading, error }] = useCreateRoleMutation();

  const handleSubmit = async (formData) => {
    try {
      await createRole(formData).unwrap();
      toast.success('Role created successfully');
      navigate("/admin/roles");
    } catch (err) {
      toast.error(err?.data?.message || err?.error || 'Failed to create role');
    }
  };

  return (
    <div>
      <h1 className="mb-4">Add Role</h1>
      {error && (
        <div className="alert alert-danger">
          {error?.data?.message || error?.error || 'Failed to create role'}
        </div>
      )}
      <RoleForm onSubmit={handleSubmit} loading={isLoading} />
    </div>
  );
};

export default AddRolePage;
